import { combineReducers } from 'redux'
import registration from '../reducers/registration'

const reducer = combineReducers({
  registration,
})

export default reducer